import {
    checkMaxMin,
    checkOnlyDot,
    checkForEmpty,
    checkStartWithZeros,
} from './checkerFunctions'

export default function helperhandleBlur(e: any,
    setinputStake: (arg: string) => string,
    min: string,
    max: string,
    toFix: number,
    setnumber: (arg: string) => void,
    handleNotification: () => void,
    currency: string | undefined,
    type: string,
    isZero?: boolean | false) {
    const n = e.target.value


    if (checkForEmpty(n)) {
        setinputStake((+min).toFixed(toFix))
        setnumber(min.toString())
        return
    }
    if (checkOnlyDot(n)) {
        setinputStake((+min).toFixed(toFix))
        setnumber(min.toString())
        return
    }

    const wz: string = checkStartWithZeros(n)
    let m = checkMaxMin(wz, max, min, handleNotification, currency, toFix, isZero)
    if (type === 'numbersAndDot' || type === 'onlyNumbers' || type === 'numbersDotComma') {
        m = (+m).toFixed(toFix)
    }
    setinputStake(m)
    setnumber(m)
}
